import createContext from 'create-react-context';
const RowContext = createContext({});
export default RowContext;
